import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import translate from "@insite/client-framework/Translate";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Link from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

interface Props extends WidgetProps {
    fields: {
        [fields.textFieldValue1]: string;
        [fields.multilineTextFieldValue]: string;
        [fields.textFieldValue2]: string;
        [fields.imagePickerFieldValue]: any;
    };
}

const enum fields {
    textFieldValue1 = "textFieldValue1",
    multilineTextFieldValue = "multilineTextFieldValue",
    textFieldValue2 = "textFieldValue2",
    imagePickerFieldValue = "imagePickerFieldValue",
}

export interface ListItemWidgetStyle {
    image?: LazyImageProps;
    container?: InjectableCss;
    innerDiv?: InjectableCss;
    innerTitle?: InjectableCss;
    Title?: InjectableCss;
    description?: InjectableCss;
    content?: InjectableCss;
}

const listItemWidgetStyle: ListItemWidgetStyle = {
    image: {
        css: css`
            width: 100%;
        `,
    },
    container: {
        css: css`
            // display: flex;
            justify-content: space-between;
            > div > div[class^="GridWrapper"] {
                max-width: 1350px;
                > div[class^="GridOffset"] {
                    width: 100%;
                    padding: 50px 0;
                    margin-bottom: 30px;
                    margin-left: auto;
                    margin-right: auto;
                    > div[class^="GridItemStyle"] {
                        max-width: 1330px;
                        margin-left: auto;
                        margin-right: auto;
                    }
                    > div[class^="GridItemStyle"]:first-child {
                        padding-left: 0;
                        padding-right: 0;
                        max-width: 100%;
                    }
                }
            }
        `,
    },
    innerDiv: {
        css: css`
            padding: 20px;
            display: block;
            margin: 20px;
            border: 1px solid #efefef;
        `,
    },
    innerTitle: {
        css: css`
            border-bottom: 0;
            margin-bottom: 0;
            width: 90%;

            font-size: 28px;
            color: #005cb9;
            display: inline-block;
            margin: 0 0 10px;
            padding-bottom: 5px;
            text-transform: uppercase;
            line-height: 26px;
        `,
    },
    Title: {
        css: css`
            font-size: 20px;
            padding: 0 20px;
            font-weight: 700;
        `,
    },
    description: {
        css: css`
            img {
                width: 40px;
            }
            display: flex;
        `,
    },
    content: {
        css: css`
            padding-left: 10px;
        `,
    },
};

const ListItemWidget: React.FC<Props> = props => {
    return (
        <>
            <StyledWrapper {...listItemWidgetStyle.container}>
                <StyledWrapper {...listItemWidgetStyle.Title}>{props.fields.textFieldValue1}</StyledWrapper>
                <StyledWrapper {...listItemWidgetStyle.innerDiv}>
                    <StyledWrapper {...listItemWidgetStyle.innerTitle}>{props.fields.textFieldValue2}</StyledWrapper>
                    <StyledWrapper {...listItemWidgetStyle.description}>
                        <StyledWrapper {...listItemWidgetStyle}>
                            <LazyImage
                                src={props.fields.imagePickerFieldValue}
                                altText={translate("home")}
                                {...listItemWidgetStyle.image}
                            />
                        </StyledWrapper>
                        <StyledWrapper {...listItemWidgetStyle.content}>
                            {props.fields.multilineTextFieldValue}
                        </StyledWrapper>
                    </StyledWrapper>
                </StyledWrapper>
            </StyledWrapper>
        </>
    );
};

const definition: WidgetDefinition = {
    group: "Common",
    fieldDefinitions: [
        {
            name: fields.textFieldValue1,
            displayName: "Text",
            editorTemplate: "TextField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "text tip",
            placeholder: "text placeholder",
            isRequired: false,
        },
        {
            name: fields.textFieldValue2,
            displayName: "Text",
            editorTemplate: "TextField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "text tip",
            placeholder: "text placeholder",
            isRequired: true,
        },
        {
            name: fields.multilineTextFieldValue,
            displayName: "MultilineText",
            editorTemplate: "MultilineTextField",
            defaultValue: "",
            fieldType: "General",
            tooltip: "multi line tip",
            placeholder: "multi line placeholder",
            isRequired: true,
        },
        {
            name: fields.imagePickerFieldValue,
            displayName: "File",
            editorTemplate: "ImagePickerField",
            defaultValue: "",
            fieldType: "General",
            isRequired: false,
        },
    ],
};

const widgetModule: WidgetModule = {
    component: ListItemWidget,
    definition,
};

export default widgetModule;
